import React from 'react';
import { useT } from '../i18n';
import './PageSpinner.css';

// ── LOADING, NOT EMPTY ───────────────────────────────────────────────────────
// Waiting for a page's contents used to render `.sp-empty` — the same dashed
// box used for "there is nothing here". The two states look identical for as
// long as the fetch takes, so a slow connection reads as an empty account.
//
// A spinner says the opposite thing: something is coming, wait. No box, no
// border — a circle on the page, which is what a delay looks like everywhere
// else in the app.
export default function PageSpinner({ label }) {
  const { t } = useT();
  // `role="status"` announces it to a screen reader without stealing focus, and
  // the label is real text rather than an aria attribute so it stays translated.
  return (
    <div className="pspin" role="status" aria-live="polite">
      <span className="pspin-ring" aria-hidden="true" />
      <span className="pspin-label">{label || t('search_loading')}</span>
    </div>
  );
}
